import { getValidationResolver, useForm } from '@common-fe/common-fe';
import dayjs from 'dayjs';
import * as yup from 'yup';

import { VALIDATORS } from '@/common';
import { DEFAULT_DATE_FORMAT, REQUIRED_TEXT } from '@/common/constants';

import { AuthorizedUser } from '../../../authorizedUsers.types';

export enum FormFields {
  firstName = 'firstName',
  lastName = 'lastName',
  relationshipType = 'relationshipType',
  birthOn = 'birthOn',
}

export interface AuthorizedUserFormValues {
  [FormFields.firstName]: string;
  [FormFields.lastName]: string;
  [FormFields.relationshipType]: string;
  [FormFields.birthOn]: string;
}

interface Props {
  defaultValue?: AuthorizedUser | null;
}

const useAuthorizedUserForm = ({ defaultValue }: Props) => {
  const methods = useForm<AuthorizedUserFormValues>({
    defaultValues: {
      [FormFields.firstName]: defaultValue?.firstName || '',
      [FormFields.lastName]: defaultValue?.lastName || '',
      [FormFields.relationshipType]: defaultValue?.relationshipType || '',
      [FormFields.birthOn]: defaultValue?.birthOn
        ? dayjs(defaultValue.birthOn).format(DEFAULT_DATE_FORMAT)
        : '',
    },
    resolver: getValidationResolver<AuthorizedUserFormValues>({
      [FormFields.firstName]: yup.string().required(REQUIRED_TEXT),
      [FormFields.lastName]: yup.string().required(REQUIRED_TEXT),
      [FormFields.relationshipType]: yup.string().required(REQUIRED_TEXT),
      [FormFields.birthOn]: VALIDATORS.DATE_FORMAT_MAX_TODAY.required(REQUIRED_TEXT),
    }),
  });

  return { methods };
};

export default useAuthorizedUserForm;
